import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import { useTrackView } from 'src/app/shared/hooks/tracking';

type PsfComboVariant = {
	readonly variantName: string;
	readonly data: {
		readonly amount: number;
	};
};

export function useTrackPageView(): void {
	const {
		data: {
			petition: { geoReach, relevantLocationLocalizedName, categoryTags },
			bandits: { psfCombo },
		},
	} = usePsfPromoteOrSharePageData();

	useTrackView('combo_psf_view', {
		geo_reach: geoReach ?? undefined,
		category_tags: categoryTags,
		relevant_location_localized_name: relevantLocationLocalizedName ?? undefined,
		combo_bandit_value: (psfCombo.variant as PsfComboVariant | undefined)?.data.amount ?? undefined,
	});
}
